import Vue from "vue";
import VueRouter from "vue-router";
import Home from "../views/Home.vue";
import NotFound from "../views/Errors/NotFound.vue";
import Subscribe from "../views/Subscribe.vue";
import Cookie from "js-cookie";
import store from "./../store";
import Auth from "./Auth";
import Account from "./Account";
import Player from "./Player";
import Pro from "./Pro";
import AcceptInvite from "../views/Accept-invite.vue";
import { rejectAdminLogin } from "@/utils/rejectAdminLogin";
//import NProgress from 'nprogress'
//import 'nprogress/nprogress.css';

//NProgress.configure({ showSpinner: false });

Vue.use(VueRouter);

const routes = [
    {
        path: "/",
        name: "Home",
        component: Home,
        meta: {
            isAuth: true,
        },
    },
    {
        path: "/subscribe",
        name: "Subscribe",
        component: Subscribe,
        meta: {
            isSubscribePage: true,
            isAuth: true,
        },
    },
    {
        path: "/onboard",
        name: "Onboard",
        component: () => import("../views/Onboarding3.vue"),
        meta: {
            isAuthPage: true,
        },
    },
    {
        path: "/accept-invite",
        name: "AcceptInvite",
        component: AcceptInvite,
        meta: {
            isAuthPage: true,
        },
    },
    ...Auth,
    ...Account,
    ...Player,
    ...Pro,
    {
        path: "/404",
        component: NotFound,
    },
    {
        path: "*",
        redirect: "/404",
    },
];

function setScrollPosition(x, y) {
    document.body.scrollTop = y;
    document.documentElement.scrollTop = y;
    window.scrollTo(x, y);
}

const router = new VueRouter({
    mode: "history",
    base: process.env.BASE_URL,
    scrollBehavior(to, from, savedPosition) {
        if (savedPosition) {
            return new Promise((resolve) => {
                setScrollPosition(savedPosition.x, savedPosition.y);
                resolve(savedPosition);
            });
        }

        return new Promise((resolve) => {
            setTimeout(() => {
                setScrollPosition(0, 0);
                resolve({ x: 0, y: 0 });
            }, 0);
        });
    },
    routes,
});

router.beforeEach(function (to, from, next) {
    if (store.state.user && store.state.user.type === "admin") {
        rejectAdminLogin(store.state.user);
        return next("/login?home=show");
    }

    if (to.meta.isAuth) {
        if (!Cookie.get(process.env.VUE_APP_AUTH_COOKIE_NAME)) {
            return next("/login");
        }
    }

    // subscription is no longer required for Pro accounts
    //   if(!to.meta.isAuthPage && !to.meta.isSubscribePage){
    //       if(store.state.user){
    //         if(store.state.user.type == 'pro' && !store.state.user.subscribed){
    //           router.push('/subscribe').catch(()=>{});
    //           return;
    //         }
    //       }
    //   }

    if (Cookie.get(process.env.VUE_APP_AUTH_COOKIE_NAME)) {
        window.axios.defaults.headers.common["Authorization"] =
            "Bearer " + Cookie.get(process.env.VUE_APP_AUTH_COOKIE_NAME);
        if (!store.state.user) {
            store.dispatch("getUser");
            store.dispatch("getAdvertisements");
        }
    }
    next();
});

router.beforeResolve((to, from, next) => {
    // If this isn't an initial page load.
    if (to.name) {
        // Start the route progress bar.
        // NProgress.start()
    }
    next();
});

export default router;
